<template>
    <div class="notfound">
        <div class="box">
            <img src="../assets/blank/notfound.png" alt="">
            <p class="news">抱歉，你访问的页面不存在或仍在开发中</p>
            <button class="homebtn" @click="gohome">返回首页</button>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        gohome(){
            this.$router.push({path:'/'})
        }
    }
}
</script>

<style lang="stylus" scoped>
.box{
    margin:0 auto;
    height:635px;
    width:1205px;
    text-align center;
    img{
        display:block; 
        margin:0 auto;
        margin-top:50px;
    }
    .news{
        font-size:18px;
        color:#666;
        margin-bottom:50px;
    }
    .homebtn{
        width: 120px;
        margin:0 auto;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: #f0cd48;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        border-radius: 3px;
        border:0;
    }
}
</style>